var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmRightBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74701",
    "data-name": "Group 74701",
    transform: "translate(12656 -13533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74721",
    "data-name": "Group 74721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    transform: "translate(-12656 13533)",
    fill: "none",
    stroke: "#1bbc8d",
    strokeWidth: 4,
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 53.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M58.49,16.141,27.736,47.455,13.756,33.221",
    transform: "translate(-12636.418 13556.908)",
    fill: "none",
    stroke: "#1bbc8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmRightBig);
export default __webpack_public_path__ + "static/media/ConfirmRightBig.88438edf3773cbdd61f778a968b25bc3.svg";
export { ForwardRef as ReactComponent };